// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RUUvnWgXWAGEmK {
  display: flex;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  animation: wsxbf_JogA7emK 3000ms cubic-bezier(0.55, 0.055, 0.675, 0.19) infinite;
  border-radius: var(--ds-border-radius-100, 3px);
}
@media (prefers-reduced-motion: reduce) {
  .RUUvnWgXWAGEmK {
    animation: none;
  }
}
@keyframes wsxbf_JogA7emK {
  0%,
  33% {
    box-shadow: 0 0 0 2px var(--ds-border-discovery, #8270db), 0 0 0 var(--ds-border-discovery, #6554c0);
  }
  66%,
  100% {
    box-shadow: 0 0 0 2px #6554c0, 0 0 0 10px rgba(101, 84, 192, 0.01);
  }
}
.mOdYV1_Z_uqnEa:active {
  pointer-events: none;
}
`, ""]);
// Exports
export var pulse = `RUUvnWgXWAGEmK`;
export var pulsing = `wsxbf_JogA7emK`;
export var disableClicks = `mOdYV1_Z_uqnEa`;
export default ___CSS_LOADER_EXPORT___;
